import React from 'react'
import OnBoarding from './OnBoarding'
import { OnBoardingProvider } from '../../../contexts/OnBoardingContext'

// Wrapper component that provides the OnBoardingProvider context
const OnBoardingWrapper = (props: any) => {
  return (
    <OnBoardingProvider>
      <OnBoarding {...props} />
    </OnBoardingProvider>
  )
}

export const ROUTES = [
  {
    component: OnBoardingWrapper,
    isPublic: true,
    path: '/onboarding',
    slug: 'login',
    title: 'Login',
    isProtected: true,
    showMenu: false,
    redirectTo: '/profile',
  },
  {
    component: OnBoardingWrapper,
    isPublic: true,
    path: '/onboarding/stores',
    slug: 'login',
    title: 'Login',
    isProtected: true,
    showMenu: false,
    redirectTo: '/profile',
  },
]
